const org = {
  orgName: 'Organization',
  integrator: 'Integrator',
  orgDescription: 'Descripition',
  integratorDescription: 'Descripition',
  orgAddress: 'Address',
  integratorAddress: 'Address',
  createTime: 'Create Time',
  linkMan: 'Link Man',
  phone: 'Phone',
  email: 'Email',
  usefulLife: 'Useful Life',
  parentName: 'Parent Name',
  validateTip: {
    orgNameRequired: ' organiztion name is required',
    integratorRequired: ' integrator name is required',
    orgNameRule: ' organiztion name must less than 30 chars',
    integratorRule: ' integrator name must les than 30 chars',
    orgDescriptionRequired: ' organiztion description is required',
    integratorDescriptionRequired: ' integrator description is required',
    orgDescriptionRule: ' organiztion description must less than 200 chars',
    integratorDescriptionRule: ' integrator description must less than 200 chars',
    phoneRule: 'please input correct phone No.',
    emailRule: 'please input correct emali address',
    linkManRule: 'link man must less than 20 chars',
    nickNameRequired: 'nickname is required',
    nickNameRule: 'nickname must less than 20 chars',
    userNameRequired: 'username is required',
    userNameRule: 'username must less than 20 chars',
    passwordRequired: 'password is required',
    passwordRule: 'password length must 6 to 20 ',
    confirmPasswordRequired: 'please input password again',
    confirmPasswordRule: 'sorry the password you input is not same',
  },
  editBasicInfo: 'Edit Basic Info',
  userInfo: 'User Info',
  password: 'Password',
  confirmPassword: 'Confirm',
  editUserInfo: 'Edit User Info',
  userName: 'User Name',
  role: 'Role',
  nickName: 'Nick Name',
  autoRefresh: 'Keep Logining',
  avatar: 'Avatar',
  refresh: 'Yes',
  autoOver: 'No',
  locationInfo: 'Location',
  smsService: 'SMS Service',
  recharge: 'Recharge',
  smsNum: 'SMS',
  isShare: 'Share',
  receiveUser: 'Receive User',
  receivePhone: 'Recevice Phone',
  rechargeSms: 'SMS Recharge',
  topUp: 'Top Up',
  recycle: 'Recycle',
  smsLabel: 'Please Input {text} num',
  rechargeSuccess: 'Recharge SMS Successfully',
  errData: 'The input data is not valid',
  customInfo: 'Custom Info',
  systemName: 'System Name',
  systemLogo: 'System Logo',
  entityTemplate: 'Entity Template',
  enableShare: 'Enable Share SMS',
  disableShare: 'Disable Share SMS',
  pre: 'Pre',
  next: 'Next',
  addOrgSuccess: 'Create New Orgnaiztion SuccessFully',
  scenes: 'Associated Scenarios',
  createUser:'Add New User',
  TopOrg:'Top institutions',
  Org:'Lower level institutions',
  Attach:'Sub users',
}
export default org
